<template>
  <div id="Content">

    <!-- <div style="width: 53%;position: absolute;">
      <div id="rectangle"></div>
      <div id="triangle-right"></div>
    </div> -->

    <Information/>
    <div class="container">

      <div class="row">
        <div class="column kolumna-1">
          <!-- <DragDrop :device="item"/> -->
          <ItemsRack/>
        </div>
        <div class="column kolumna-2">
          <DaneWejsciowe @clicked="onClickChild"/>
          <div class="form-group" style="float: right;position: relative;right: 0px;width: 126px;margin: 0px;bottom: 10px;">
            <button class="btn btn-info" @click="pokaz_zestawienie = true">{{$t('message.wynik')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- <Example/> -->
    <Podsumowanie
      :showDialog="pokaz_zestawienie"
      @clickedClose="closedDialog"
    />

  </div>
</template>

<script>
import { mapState } from 'vuex'
import DaneWejsciowe from './DaneWejsciowe'
import DragDrop from './DragDrop'
import Podsumowanie from './Dialogs/Podsumowanie'
import Information from './Dialogs/Information.vue'
import Example from './nested/nested-example'

import ItemsRack from './ItemsRack'

export default {
  name: 'Content',
  // mixins: [app, calculation],
  data () {
    return {
      item: [],
      pokaz_zestawienie: false
    }
  },
  components: {
    DaneWejsciowe, DragDrop, Podsumowanie, Information, Example, ItemsRack
  },
  computed: {
    ...mapState('app', ['count'])
  },
  methods: {
    onClickChild (value) {
      this.item = value
    },
    podsumowanie () {
      console.log('podsumowanie')
    },
    closedDialog (bool) {
      this.pokaz_zestawienie = bool
    },
    check_language (lang) {
      if (Object.keys(this.$i18n.messages).indexOf(lang) > -1) {
        this.$i18n.locale = this.$route.params.locale
      } else {
        this.$i18n.locale = 'en'
        this.$route.params.locale = 'en'
      }
    }
  },
  created () {
    console.log('--- content ---')
    this.check_language(this.$route.params.locale)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Content {
background: #efefef;
width: 100%;
}
/* #triangle-right {
  width: 0;
  height: 0;
  border-top: 40px solid transparent;
  border-left: 100px solid red;
  border-bottom: 40px solid transparent;
  position: absolute;
  right: 0px;
  top: -15px;
  z-index: 9;
}
#rectangle {
  height: 50px;
  width: 100px;
  background-color: #555;
} */
.container {
  max-width: 1240px;
  background: #efefef;
  margin: 0px auto;
}
.row {
margin-top: 15px;
margin:0px auto;
/* display: inline-flex; */
display: inline-block;
width: 100%;
}
.topInfo {
width: 100%;
padding: 4px;
background: #fff;
text-align: left;
color: red;
position: fixed;
z-index: 2;
top: 80px;
}
.topInfo button {
  background: none;
  border:none;
  color: red;
  cursor: pointer;
}
.dialogInfo {
  width: 100%;
  padding: 10px;
  background: #fff;
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo svg{
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo button{
  background: none;
  border:none;
  color: red;
  cursor: pointer;
  float:right
}
select.form-control {
    overflow: scroll;
    overflow-x: hidden;
}
.kolumna {
  padding: 0px;
  /* max-height: 790px; */
}

.column {
  float: left;
  width: 50%;
  /* height: 300px; Should be removed. Only for demonstration */
}
.kolumna-1 {
  width: 55%;
  min-width: 430px;
}
.kolumna-2 {
  width: 45%;
  min-width: 320px;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue